import {
  GamesSharesClient,
  GameShareLink,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gamesClient = new GamesSharesClient(apiConfig, undefined, axiosInstance);

export const handleCreateGameShareLink = async (
  gameId: string
): Promise<GameShareLink> => {
  return (await gamesClient.createGameShareLink(gameId)).data;
};
